export default {
  setServices: (state, payload) => {
    state.services = payload;
  },
  setServiceDetails: (state, payload) => {
    state.serviceDetails = payload;
  },
};
